// Add your custom JS here.
(function ($) {
    'use strict';

    $(document).ready(function () {

        // ─── Sticky header on scroll ───────────────────────────────────────
        // Adds .sticky to .header-bottom after scrolling 130px.
        // TODO: Adjust the scroll threshold and target selector to match the
        //       project's header markup.
        $(window).scroll(function () {
            if ($(this).scrollTop() > 130) {
                $('.header-bottom').addClass('sticky');
            } else {
                $('.header-bottom').removeClass('sticky');
            }
        });

        // ─── Scroll-triggered animations ──────────────────────────────────
        // Adds .in-view to .animated elements when they enter the viewport.
        // Pair with CSS animations in _child_theme.scss.
        // For elements using data-animation / data-animation-duration attributes,
        // the animation name and duration are applied as inline styles.
        function checkInView() {
            $('.animated').each(function () {
                var elementTop     = $(this).offset().top;
                var elementBottom  = elementTop + $(this).outerHeight();
                var viewportTop    = $(window).scrollTop();
                var viewportBottom = viewportTop + $(window).height();
                var inView         = elementTop < viewportBottom - 50 && elementBottom > viewportTop;

                if (inView) {
                    $(this).addClass('in-view');
                    var animation = $(this).data('animation') || 'fadeIn';
                    var duration  = $(this).data('animation-duration') || '1.5s';
                    $(this).css({
                        'animation-name':            animation,
                        'animation-duration':         duration,
                        'animation-timing-function':  'ease'
                    });
                } else {
                    $(this).removeClass('in-view');
                    $(this).css({
                        'animation-name':            'none',
                        'animation-duration':         '',
                        'animation-timing-function':  ''
                    });
                }
            });
        }

        $(window).on('scroll resize', checkInView);
        checkInView();

        // ─── TODO: Add project-specific JS below ──────────────────────────

    });

})(jQuery);
